module.exports = __webpack_public_path__ + "static/media/superBlot-1.f385c555.png";